import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PremiosImg from "../../assets/images/premios.jpg";
import "./Premios.css";

export default function Premios() {
  return (
    <Container>
      <Row id="premios">
        <Col className="title-col">
          <h2 className="section-title">PRÊMIOS</h2>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="premios-col">
          <img src={PremiosImg} alt="Prêmios" className="premios-image" />
        </Col>
        <Col md={6}>
          <div className="premios-table">
            <div className="premios-table-line">
              <p className="premios-table-bold">Prêmio</p>
              <p className="premios-table-bold">Data do Sorteio</p>
            </div>
            <div className="premios-table-line-light">
              <p className="premios-table-light">
                Ar-condicionado da marca Electrolux, modelo JI12R Quente e frio,
                12.000 btus
              </p>
              <p className="premios-table-bold">14/03/2026</p>
            </div>
            <div className="premios-table-line">
              <p className="premios-table-light">
                Geladeira da marca Consul, modelo Frost Free 410 L
              </p>
              <p className="premios-table-bold">11/04/2026</p>
            </div>
            <div className="premios-table-line-light">
              <p className="premios-table-light">
                Televisor da marca AOC, modelo Smart 43”
              </p>
              <p className="premios-table-bold">09/05/2026</p>
            </div>
            <div className="premios-table-line">
              <p className="premios-table-light">
                Ar-condicionado da marca Electrolux, modelo JI12R Quente e frio,
                12.000 btus
              </p>
              <p className="premios-table-bold">13/06/2026</p>
            </div>
            <div className="premios-table-line-light">
              <p className="premios-table-light">
                Geladeira da marca Consul, modelo Frost Free 410 L
              </p>
              <p className="premios-table-bold">11/07/2026</p>
            </div>
            <div className="premios-table-line">
              <p className="premios-table-light">
                Televisor da marca AOC, modelo Smart 43”
              </p>
              <p className="premios-table-bold">08/08/2026</p>
            </div>
            <div className="premios-table-line-light">
              <p className="premios-table-light">
                Notebook da marca Lenovo, modelo Core i3
              </p>
              <p className="premios-table-bold">12/09/2026</p>
            </div>
            <div className="premios-table-line">
              <p className="premios-table-light">
                Televisor da marca AOC, modelo Smart 43”
              </p>
              <p className="premios-table-bold">10/10/2026</p>
            </div>
            <div className="premios-table-line-light">
              <p className="premios-table-light">
                Geladeira da marca Consul, modelo Frost Free 410 L
              </p>
              <p className="premios-table-bold">14/11/2026</p>
            </div>
            <div className="premios-table-line">
              <p className="premios-table-light">
                Ar-condicionado da marca Electrolux, modelo JI12R Quente e frio,
                12.000 btus
              </p>
              <p className="premios-table-bold">12/12/2026</p>
            </div>
            <div className="premios-table-line-light">
              <p className="premios-table-light">
                Motocicleta 0km da marca Honda, modelo CG 160, ano 2025, modelo
                2026
              </p>
              <p className="premios-table-bold">09/01/2027</p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
